import { Environment } from "@octopusdeploy/utilities";
import React from "react";

export const DevOnly: React.FC = ({ children }) => {
    return <React.Fragment>{Environment.isInDevelopmentMode() && children}</React.Fragment>;
};

export default DevOnly;
